import { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { Switch, Route, Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Components
import LoginForm from "./LoginForm";

// Services
import localStorage from "../../../../services/storage/LocalStorage";

// Providers
import { useUserInfo } from "../../../../contexts/userInfoContext";

const Login = () => {
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const { t } = useTranslation();

	const userInfo = useUserInfo();

	useEffect(() => {
		const logoutMessage = localStorage.getPathName("logoutMessage");
		if (logoutMessage) {
			const translated = t(logoutMessage);
			setError(translated || logoutMessage);
			localStorage.clearPathName("logoutMessage");
		}
	}, [t]);

	if (userInfo) {
		return (
			<Switch>
				<Route path="*">
					<Redirect to="/questionnaire" />
				</Route>
			</Switch>
		);
	}

	return (
		<Grid>
			<LoginForm
				isLoading={isLoading}
				setIsLoading={setIsLoading}
				error={error}
				setError={setError}
				message={message}
				setMessage={setMessage}
			/>
		</Grid>
	);
};

export default Login;
